<jhi-loader></jhi-loader>
<!-- CARRINHO DE COMPRAS -->
@if (!isJuridica()) {
  <div class="shopping-cart container overflow-hidden" style="margin-bottom: 12px;">
    <div mat-dialog-title class="modal-title">
      <h1>{{'Carrinho' | translate}}</h1>
      <a (click)="onNoClick()">X</a>
    </div>
    <div mat-dialog-content class="d-flex flex-column content">
      <mat-divider></mat-divider>
      <div class="overflow-auto">
        <table class="table-carrinho">
          <tr class="text-center">
            <th mat-header="remover"></th>
            <th mat-header="nome">{{'Nome' | translate}}</th>
            <th mat-header="quantidade">{{'Quantidade' | translate}}</th>
            <th mat-header="valorTotal">Total</th>
          </tr>
          @for (item of produtoscarrinho; track item; let i = $index) {
            <tr class="text-center gap-2">
              <td>
                <button type="button" class="remove-product" (click)="deletar(i)">
                  X
                </button>
              </td>
              <td>{{item.nome | translate}}</td>
              <td>{{item.quantidadeKg/1000 | currency:"":"":'1.0-4'}} Ton</td>
              <td>{{item.valorTotal | currency: 'BRL'}}</td>
            </tr>
          }
          <div class="mt-2"></div>
          <tr class="divider text-center">
            <th class="text-center results" mat-header="total">Total CO2</th>
            <th></th>
            <th class="results" mat-header="quantidadeTotal">{{totalCo2() | currency:"":"":'1.0-4'}} Ton</th>
            <th class="results" mat-header="total" style="font-size: x-large; color: #2A663A;">{{valorTotalCarrinho() | currency: 'BRL'}}</th>
          </tr>
        </table>
      </div>
    </div>
    <div class="divider"></div>
    <div class="buttons">
      <button type="button" class="btn btn-outline-success" (click)="redirectToCalc()">{{'Continuar comprando' | translate}}</button>
      <button type="button" class="btn btn-success btn-lg checkout" (click)="openDialogCompra()" [disabled]="totalCo2() <= 0">{{'Finalizar compra' | translate}}</button>
    </div>
  </div>
}

<!-- JURIDICA -->
@if (isJuridica()) {
  <div class="shopping-cart container overflow-hidden" style="margin-bottom: 12px;">
    <div mat-dialog-title class="modal-title">
      <h1>{{'Resultado' | translate}}</h1>
      <a (click)="onNoClick()">X</a>
    </div>
    <div class="divider"></div>
    @if (!isLoggedIn() && !formContatoSend) {
      <div mat-dialog-content class="d-flex flex-column content">
        <div mat-dialog-content class="content">
          <h3>{{'Estamos quase lá. Por favor nos informe' | translate}}:</h3>
          <form [formGroup]="contactForm" (ngSubmit)="save()">
            <div class="d-flex flex-column forms">
              <mat-form-field class="example-half-width" style="margin-right: 3%;">
                <mat-label>{{'Nome' | translate}}</mat-label>
                <input formControlName="nome" matInput type="text">
              </mat-form-field>
              <mat-form-field class="example-half-width" style="margin-right: 3%;">
                <mat-label>E-mail</mat-label>
                <input formControlName="email" matInput type="text">
              </mat-form-field>
              <mat-form-field class="example-half-width" style="margin-right: 3%;">
                <mat-label>{{'Telefone' | translate}}</mat-label>
                <input formControlName="telefone" matInput type="text" mask="(00) 0000-0000||(00) 0 0000-0000">
              </mat-form-field>
            </div>
            <div class="divider">
            </div>
            <div class="buttons">
              <button type="button" class="btn btn-outline-success" (click)="onNoClick()">{{'Fechar' | translate}}</button>
              <button type="submit" class="btn btn-success" [disabled]="!contactForm.valid || isSaving">{{'Continuar' | translate}}</button>
            </div>
          </form>
        </div>
      </div>
    }
    <div>
      @if (formContatoSend) {
        <div mat-dialog-content class="d-flex flex-column content">
          <div class="d-flex justify-content-center">
            <div class="d-flex flex-column result">
              <h3 style="hyphens: auto;">{{'Essa quantidade de' | translate}} <strong>{{data.quantidadeKg/1000 | currency:'':'':'1.0-2'}} Ton </strong>{{'de pegada de CO2e pode ser compensada no valor de' | translate}} <strong style="font-size: x-large; color: #2A663A;">{{data.custo | currency: 'BRL'}}</strong>
              @if (data.typeProduct && !(data.typeProduct.includes('Administrativo'))) {
                <span> ou
                  <strong style="font-size: x-large; color: #2A663A;">{{calculatePerKg() | currency:'':'':'1.0-2'}} R$/
                    @if (!isLitre()) {
                      <span>kg </span>
                    }
                    @if (isLitre()) {
                      <span>L</span>
                    }
                  </strong>
                  @if (!(data.typeProduct === 'Peça')) {
                    <span>{{'de' | translate}}</span>
                  }
                  @if (data.typeProduct === 'Peça') {
                    <span>{{'por' | translate}}</span>
                    } {{data.typeProduct | translate}}
                  </span>
                }
              </h3>
              <p>({{'1,0 Tonelada de CO2' | translate}} = {{104 | currency: 'BRL'}})</p>
            </div>
          </div>
          <div class="divider">
          </div>
          <div class="d-flex flex-column  align-items-center w-100">
            <div class="flex-grow-1">
              <p class="alert alert-success mt-2" style="text-align: justify;">{{'Achou interessante' | translate}}?<br>
              {{'Oferecemos soluções personalizadas para que sua empresa possa contribuir com o consumo sustentável apoiando os produtores rurais na manutenção e aumento de suas áreas de mata nativa' | translate}}.</p>
            </div>
            <div class="d-flex justify-content-end w-100">
              <button type="button" class="btn btn-success btn-lg checkout" (click)="navitageToContato()">{{'Fale conosco' | translate}}</button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
